const mutations = {
	SET_CREATE_AB (state, data) {
		state.url = data
	},
	SET_LOGS (state, data) {
		state.logs = data.content
		state.totalPages = data.totalPages,
		state.totalElements = data.totalElements
		state.currentPage = data.number
	},
	SET_CURRENT_PAGE (state, data) {
		state.currentPage = data
	},
	SET_LOGS_TO_EDIT (state, data) {
		const logsInfo = JSON.parse(JSON.stringify(data))
		state.logsToEdit = {
			...logsInfo
		}
	},
	SET_LOGS_EDIT (state, data) {
		// const logsInfo = JSON.parse(JSON.stringify(data))
		state.logsToEdit = ''
		state.logsToEdit = data
	},
	SET_LOGS_PAGINATION (state, data) {
		let paginationInfo = JSON.parse(JSON.stringify(data))
		if (paginationInfo.total_elements <= 30 ) {
			paginationInfo.total_pages = 1
		} else {
			paginationInfo.total_pages = Math.trunc(paginationInfo.total_elements/30)+1
		}
		state.pagination = {
			...state.pagination,
			...paginationInfo
		}
	},
	
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/splitTest/mutations.js